import { render, staticRenderFns } from "./HotelDishes.vue?vue&type=template&id=75f511bd&scoped=true&"
import script from "./HotelDishes.vue?vue&type=script&lang=js&"
export * from "./HotelDishes.vue?vue&type=script&lang=js&"
import style0 from "./HotelDishes.vue?vue&type=style&index=0&id=75f511bd&prod&lang=scss&"
import style1 from "./HotelDishes.vue?vue&type=style&index=1&id=75f511bd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75f511bd",
  null
  
)

export default component.exports